import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getUnitsList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/unit/list.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUnit(axiosPrivate, id) {
	return axiosPrivate
		.get(`${apiURL}/unit/${id}.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

// Every unit of the organization (flat, children included) with its members and their unit roles
export async function getUnitsWithMembers(axiosPrivate) {
	const res = await axiosPrivate.get(`${apiURL}/organization-unit.json`);
	return Array.isArray(res.data) ? res.data : [];
}

export async function addUnit(axiosPrivate, navigate, data) {
	return axiosPrivate
		.post(`${apiURL}/organization-unit.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Unit added");
				navigate(`/units/${res.data.id}`, { replace: true });
			} else {
				toast.error("Could not add unit. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			toast.error(
				err.response?.data?.fieldErrors?.map((e) => e.message).join(", ") ||
					err.response?.data?.message ||
					"Adding units - error, try again"
			);
			return err.response;
		});
}

export async function editUnit(axiosPrivate, id, data, cb = false) {
	return axiosPrivate
		.patch(`${apiURL}/organization-unit/${id}.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Unit updated");
				if (cb) cb();
			} else {
				toast.error("Could not update unit. Please try again.");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteUnit(axiosPrivate, id) {
	return axiosPrivate
		.delete(`${apiURL}/organization-unit/${id}.json`)
		.then((res) => {
			if (res.status >= 200 && res.status < 300) {
				toast.success("Unit deleted");
				return true;
			} else {
				toast.error("Could not delete unit. Please try again.");
				return false;
			}
		})
		.catch((err) => {
			toast.error("Could not delete unit. Please try again.");
			return false;
		});
}